import { Spinner } from "~/shared/ui/kit/components/Spinner"
import type { SpinnerProps } from "~/shared/ui/kit/components/Spinner/SpinnerProps"

const buttonSpinnerStyle = { width: "1rem" }

/**
 * Обертка вокруг `Spinner` для использования внутри `Button`
 */
export function ButtonSpinner(props: SpinnerProps) {
	return <Spinner colorStyle="light" style={buttonSpinnerStyle} {...props} />
}
